import type { FC } from 'react';
import React from 'react';
import BEMHelper from '@ynap/bem-helper';
import type { FieldRenderProps } from '@ynap/form';
import { Field as FormField } from '@ynap/form';
import { RadioButton } from '@ynap/radio-button';
import type { Messages } from '../AddressForm/@types';

const bem = new BEMHelper('AddressSelectionForm');

interface AddressRadioButtonProps {
    address: string;
    onChange: () => void;
    messages?: Messages;
    split?: boolean;
    trackAddNewAddress?: () => void;
    reduxForm?: any;
}

const AddAddressRadioButton: FC<AddressRadioButtonProps> = ({ address, messages, onChange: onChangeParent, split = false, trackAddNewAddress }) => (
        <FormField key={address} name="addressId" value="">
            {({ onChange, value, ...rest }: FieldRenderProps) => {
                const checked = address == value;
                return (
                    <RadioButton
                        {...rest}
                        checked={checked}
                        className={bem('addAddress', split ? 'split' : undefined, 'radio')}
                        id={address}
                        label={messages?.addressSelectionForm?.add?.()}
                        value={address}
                        onChange={(ev: any) => {
                            onChangeParent();
                            onChange(ev.target.value);
                        }}
                        onClick={() => {
                            onChangeParent();
                            onChange(address);
                            trackAddNewAddress?.();
                        }}
                    />
                );
            }}
        </FormField>
    );

export default AddAddressRadioButton;
